// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1JNpd","description":"PatientConsentPreview_description__3EAQG"};